// extracted by mini-css-extract-plugin
module.exports = {"slide":"list_slide_13fRJ","slide-reverse":"list_slide-reverse_2vvs3","table":"list_table_2eT1k","componentMargin":"list_componentMargin_1SXkb"};